<template>
  <section class="sign">
    <h2 class="title is-4">Firma dentro il riquadro e premi il pulsante "Conferma".</h2>
    <canvas id="signer"></canvas>
    <button class="button is-primary" type="button" @click.prevent="clearCanvas">Cancella</button>
    <button class="button is-primary" type="button" @click.prevent="perform">Conferma</button>

    <canvas id="empty-canvas" style="display: none"></canvas>
  </section>
</template>

<script>
  import SignaturePad from 'signature_pad'

  export default {
    name: 'Sign',
    props: {
      enableSignaturePad: Boolean
    },
    data () {
      return {
        signaturePad: null
      }
    },
    mounted () {
      let canvas = document.querySelector('canvas')
      let ratio = Math.max(window.devicePixelRatio || 1, 1)
      canvas.width = canvas.offsetWidth * ratio
      canvas.height = canvas.offsetHeight * ratio
      canvas.getContext('2d').scale(ratio, ratio)
      this.signaturePad = new SignaturePad(canvas)
    },
    computed: {},
    methods: {
      clearCanvas () {
        this.signaturePad.clear()
      },
      perform () {
        let dataURL = this.signaturePad.toDataURL('image/png', 0.5)
        if (this.signaturePad.isEmpty()) {
          console.warn('Warning: empty canvas.')
          this.$emit('error', 'Firma non apposta.')
          return false
        }
        this.$emit('signed', dataURL)
        this.clearCanvas()
      }
    },
    watch: {
      enableSignaturePad: function (val1) {
        if (val1) {
          this.signaturePad.on()
        } else {
          this.signaturePad.off()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  #signer {
    width: 100%;
    height: 30vh;
    /*max-width: 700px;*/
    /*max-height: 460px;*/
    margin-bottom: 1em;
    background: white;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/actions/Sign.vue